import {login, wxLogin, logout, getInfo, getSysInfo} from '@/api/user'
import {getToken, setToken, removeToken} from '@/utils/auth'
import router, {resetRouter} from '@/router'
import { baseURL } from "@/settings.js"
const state = {
  token: getToken(),
  name: '',
  avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
  introduction: '',
  roles: [],
  sysInfo: null,
  userInfo: null
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_SYSINFO: (state, info) => {
    state.sysInfo = info
  },
  SET_USERINFO: (state, info) => {
    state.userInfo = info
  }
}


const actions = {
  // user login
  login({commit}, userInfo) {
    const {username, password} = userInfo
    return new Promise((resolve, reject) => {
      login({username: username.trim(), password: password}).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user login
  wxLogin({commit}, userInfo) {
    const {code, state} = userInfo
    return new Promise((resolve, reject) => {
      wxLogin({code: code.trim(), state: state}).then(response => {
        const {data} = response
        commit('SET_TOKEN', data.token)
        setToken(data.token)
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(res => {
        console.log(res)
        if (res.code === 0) {
          const data = Object.assign({
            roles: ['admin','editor'],
            introduction: 'I am an editor',
            avatar: 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif',
            logo: baseURL + res.data.logoUrl,
          }, res.data)
          if (!data) {
            reject('验证失败，请再次登录.')
          }
          const {roles, name, avatar, introduction} = data
          
          // roles must be a non-empty array
          if (!roles || roles.length <= 0) {
            reject('getInfo: roles must be a non-null array!')
          }
          commit('SET_ROLES', roles)
          commit('SET_NAME', name)
          commit('SET_INTRODUCTION', introduction)
          commit('SET_USERINFO',res.data.user)
          resolve(data)
        } else {
          reject(res);
        }
        
        
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  getSysInfo({commit, state}) {
    return new Promise((resolve, reject) => {
      getSysInfo().then(res => {
        if (res.code === 0) {
          commit('SET_SYSINFO', res.data)
        }
        resolve(res.data)
      }).catch(err => {
        reject(err)
      })
    })
  },
  
  // user logout
  logout({commit, state}) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()
        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },
  
  // remove token
  resetToken({commit}) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },
  
  // dynamically modify permissions
  changeRoles({commit, dispatch}, role) {
    return new Promise(async resolve => {
      const token = role + '-token'
      
      commit('SET_TOKEN', token)
      setToken(token)
      
      const {roles} = await dispatch('getInfo')
      
      resetRouter()
      
      // generate accessible routes map based on roles
      const accessRoutes = await dispatch('permission/generateRoutes', roles, {root: true})
      
      // dynamically add accessible routes
      router.addRoutes(accessRoutes)
      
      // reset visited views and cached views
      dispatch('tagsView/delAllViews', null, {root: true})
      
      resolve()
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
